import { OlaylarTablosu } from './olaylar-tablosu.js';

export function SayfaOlaylar() {
  return (
    <div className="space-y-5">
      <header>
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">Cihaz Olayları</h1>
        <p className="text-fume-500 dark:text-fume-400 mt-1 text-sm">
          Tüm noktalardan gelen telemetri ve kapı/pil olayları — son 1000 olay, 15sn'de bir
          yenilenir.
        </p>
      </header>

      <OlaylarTablosu />
    </div>
  );
}
